import * as React from 'react';
import {
    AudienceRule as IAudienceRule,
    AudienceRuleOption
} from '@nexxt/common/types';
import { VectorMap as JVectormap } from '@nexxt-intelligence/react-jvectormap';
import {
    VECTOR_MAP_LIST,
    VECTOR_MAP_REGION_CODES
} from '@nexxt/common/constants';

interface AudienceVectorMapProps {
    totalSampleSize: number;
    audienceRule: IAudienceRule;
    countries: any;
    toggle: boolean;
    isDisabled: boolean;
    isSelected: (option: AudienceRuleOption) => boolean;
    onChangeTargettingOption: (
        response: { label: string; value: string } | boolean,
        isMultipleAnswer: boolean,
        isBuiltIn: boolean,
        index: number
    ) => void;
}
const AudienceVectorMap = (props: AudienceVectorMapProps): JSX.Element => {
    const { totalSampleSize, audienceRule, countries, toggle } = props;
    const componentRef = React.useRef();
    const currentCountry = VECTOR_MAP_LIST.find(
        (country) => country.identifier === countries[0].value
    );
    const currentCountryMapping = {};
    let flag = false;
    for (const c in VECTOR_MAP_REGION_CODES) {
        const map = c.split('/');
        if (map[3] === currentCountry.identifier) {
            flag = true;
            currentCountryMapping[VECTOR_MAP_REGION_CODES[c]] = map[4];
        } else if (map[3] !== currentCountry.identifier && flag === true) {
            break;
        }
    }
    const mapData = {};

    audienceRule.audienceRuleOptions.forEach((option) => {
        const { max } = option.sampleSize;
        const regionCode = currentCountryMapping[option.label];
        let total = -1;
        if (!toggle) {
            mapData[regionCode] = total;
        } else if (!option.mode.terminateEnabled && max && max > 0) {
            total = (max / totalSampleSize) * 100;
            total > 0 && (mapData[regionCode] = total);
        } else {
            mapData[regionCode] = total;
        }
        if (!toggle && !option.mode.terminateEnabled) {
            mapData[regionCode] = 100;
        }
    });
    // Checks if all countires are unselected
    const isEmpty = Object.values(mapData).some((item) => item > -1)
        ? false
        : true;
    return (
        <JVectormap
            map={currentCountry.value}
            ref={componentRef}
            // regionsSelectable={true}
            zoomOnScroll={false}
            zoomButtons={false}
            panOnDrag={true}
            regionStyle={{
                initial: {
                    fill: '#eaf0fa',
                    'fill-opacity': 0.9,
                    stroke: 'none',
                    'stroke-width': 0,
                    'stroke-opacity': 1
                },
                hover: {
                    'fill-opacity': 0.8
                },
                selected: {},
                selectedHover: {}
            }}
            series={{
                regions: [
                    {
                        values: mapData,
                        scale: isEmpty ? ['#d5e1f5'] : ['#d5e1f5', '#2D67CB'],
                        normalizeFunction: 'linear'
                    }
                ]
            }}
            backgroundColor={'transparent'}
            containerClassName="map ripple"
            onRegionClick={(o, s) => {
                if (!props.isDisabled) {
                    const label = Object.keys(currentCountryMapping).find(
                        (key) => currentCountryMapping[key] === s
                    );
                    let ind;
                    const updatedOption = audienceRule.audienceRuleOptions.find(
                        (opt, index) => {
                            if (opt.label === label) {
                                ind = index;
                                return true;
                            }
                        }
                    );
                    props.onChangeTargettingOption(
                        !props.isSelected(updatedOption),
                        false,
                        true,
                        ind
                    );
                }
            }}
        />
    );
};

export default AudienceVectorMap;
